export const INVALID_IDEMPOTENCY_KEY_MESSAGE = 'Invalid idempotency key.';
//# sourceMappingURL=invalid-idempotency-key-message.js.map